import { useEffect } from "react";
import { scheduleAdsenseWarmup } from "../utils/adsenseLoader";

export default function DelayedAdsenseLoader() {
  useEffect(() => scheduleAdsenseWarmup(), []);
  return null;
}
